import { PayloadAction } from '@reduxjs/toolkit';

import { PreviewState, PreviewType } from 'editor/src/store/editorModules/preview/types';

const setActivePreviewReducer = (state: PreviewState, action: PayloadAction<PreviewType | undefined>) => {
  state.activePreview = action.payload;
  // Reset personalization bar flag when closing preview or opening regular preview
  if (!action.payload) {
    state.showPersonalizationBar = false;
  }
};

export default setActivePreviewReducer;
